const Spinner = () => (
  <div className="py-4">
    <div className="flex justify-center items-center relative">
      <div className="animate-spin rounded-full h-[8rem] w-[8rem] border-b-2 border-gray-900"></div>
      <p className="py-4 text-xl absolute">Ladataan...</p>
    </div>
  </div>
);

export default Spinner;
